<template>
  <transition name="confirm-fade">
    <div v-if="isShowConfirm" class="my-confirm" @click.stop="hidden()">
      <div class="wrap ub ub-ac1 ub-pc">
          <swiper class="swiper_block" :options="swiperOption" ref="mySwiper" >
              <swiper-slide v-for="(item, index) in arr" :key="index">
                  <img id="img" :src="item.url" class="full-img" />
              </swiper-slide>
              <div class="swiper-pagination" slot="scrollbar"></div>
          </swiper>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      isShowConfirm: false, // 控制窗口的显示/隐藏
      swiperOption: {
          direction: 'horizontal',
          freeMode: false,
          observeParents: true, // 观察父组件，当父组件变化时，自己随着变化
          observer: true, // 观察自己，自己的参数变化时，更新
          centeredSlides: true, // 设置为 true 时，活动块居中显示
          loop: false, // 滑动过程中会在前后复制多个 slider, 效果看起来是循环的
          loopedSlides: 3, // 设置滑动过程中所要用到的 loop 个数
          slidesPerView: 'auto', // 同时显示的 slide 数量
          loopAdditionalSlides: 100,
          autoplay: false, //是否自动切换
          pagination: {
              el: '.swiper-pagination', // 分页器的容器
              type: 'fraction', // 设置为 fraction 类型
          },
      },

      arr: [], // 图片数组
      item: {}
    };
  },
  methods: {
    show(arr, item) {
      this.item = item;
      this.isShowConfirm = true;
      this.arr = arr;
    },
    hidden() {
      this.isShowConfirm = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.my-confirm {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 900;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.confirm-fade-enter-active {
  animation: opacity 0.3s;
}

.confirm-fade-leave-active {
  animation: outOpacity 0.2s;
}

@keyframes opacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes outOpacity {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
.wrap {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width: 100%;
}

.full-img {
  position: relative;
  width: auto;
  max-width: 99%;
  max-height: 99%;
}
.swiper-pagination {
  position: absolute;
  top: 1rem;
  left: 0;
  width: 100%;
  text-align: center;
  z-index: 10;
  color: #fff;
}
</style>
